<div class="InputsContainer" id="InputsContainer">
    <label for="dirInput">Dirección de residencia</label>
    <input
        id="dirInput"
        #searchInput
        class="InputsContainerInput"
        placeholder="Cra 123 #45-67"
        required
        onblur="this.classList.add('touched')"
        type="text"
    />
    <p class="errorMsg">Este campo no puede estar vacio*</p>
    <div [ngClass]="{visibleMap: direction, invisibleMap: !direction}" id="map"></div>
</div>
